var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1358",
    "data-name": "Group 1358",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.53,
    height: 42.942,
    viewBox: "0 0 32.53 42.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 32.53,
    height: 42.942,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M7.359,167.852c-.421.864-3.209,6.533-1.078,6.521,1.136-.006,2.447-.608,3.554-.7.889-.074,1.42-1.029,1.97-2Z",
    transform: "translate(-4.297 -131.432)",
    fill: "#c44538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M23.082,34.676c.525-1.259,8.222-21.959,8.9-25.5.159-.83.81-2.208.436-3.128C31.787,4.507,22.913,0,22.875,0c-.989.054-1.955,1.233-2.637,1.732-.423.31-1.113.911-1.984,1.715C13.148,8.158,1.8,19.822,1.019,20.688A3.6,3.6,0,0,0,0,22.7c-.3,2.83,19.267,15.234,21.7,13.756a3.59,3.59,0,0,0,1.382-1.779",
    transform: "translate(-0.001 -0.002)",
    fill: "#c44538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M3.672,111.123c1.7,2.67,2.669,5.6,1.965,8.431-.333,1.342-1.485,2.728-.981,4.134.338.942,5.456,4.24,6.434,4.146,1.459-.142,2.167-1.813,3.208-2.7,2.375-2.019,5.694-2.283,9.041-1.706Z",
    transform: "translate(-2.875 -87.012)",
    fill: "#59595a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M28,2.818C25.6,1.265,23.336-.024,22.874,0c-.989.054-1.955,1.233-2.637,1.732-.423.31-1.113.911-1.984,1.715C13.148,8.157,1.8,19.822,1.019,20.687A3.6,3.6,0,0,0,0,22.7c-.153,1.461,4.567,5.206,9.909,8.543Z",
    transform: "translate(0 -0.001)",
    fill: "#ec7063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M13.439,117.229l-9.767-6.106c1.7,2.67,2.669,5.6,1.965,8.431-.333,1.342-1.485,2.728-.981,4.134.189.526,1.452,1.522,3.071,2.517Z",
    transform: "translate(-2.875 -87.012)",
    fill: "#808285"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMarker);
export default __webpack_public_path__ + "static/media/red-marker.ac714f23128f40fcd83331f4c9d7917b.svg";
export { ForwardRef as ReactComponent };